import Button from "@components/button/Button";
import Spinner from "@components/spinner/Spinner";
import TranslatableText from "@components/translations/TranslatableText";

interface LoadMoreProps {
  isLoading: boolean;
  loadMore: () => void;
  isVisible: boolean;
}

const LoadMore = ({ isLoading, loadMore, isVisible }: LoadMoreProps) => {
  if (isVisible) {
    return <Button whileHoverProps={{ scale: 1.01 }} className="btn-secondary br-6 w-100 bg-white p-1 mt-1" onClick={loadMore}>
      {isLoading ? <Spinner size={20} isBlack /> : <TranslatableText translationKey="main.load_more" />}
    </Button>;
  }

  return null;
};

export default LoadMore;